jQuery(document).ready(function($) {
	$.browser = {
		is_mobile    : false,
		is_tablet    : false,
		is_touch     : false,
		ipad_ls      : false,
		use_mediamode: true,

		bpconfig: [
			{
				label: 'bp-mobile', config: {}
			},
			{
				label: 'bp-tablet', config: {}
			}],

		init: function() {
			$.browser.polyfills();
			$.browser.ie();
			$.browser.setMediaMode();
			// $.browser.setMobileAgent();
			$.browser.setClasses();
		},

		isTouch: function() {
			return !!("ontouchstart" in window) || !!(navigator.msMaxTouchPoints);
		},

		polyfills: function() {
			(function() {
				if (typeof window.CustomEvent === "function") return false; //If not IE

				function CustomEvent(event, params) {
					params = params || {bubbles: false, cancelable: false, detail: undefined};
					var evt = document.createEvent('CustomEvent');
					evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
					return evt;
				}

				CustomEvent.prototype = window.Event.prototype;

				window.CustomEvent = CustomEvent;
			})();
		},

		ie: function() {
			if ($.browser.getIEVersion() > 0) {
				$('body').addClass('ie');
				// Add the version number
				$('body').addClass('ie' + $.browser.getIEVersion());
			}
		},

		getIEVersion: function() {
			var sAgent = window.navigator.userAgent;
			var Idx = sAgent.indexOf("MSIE");

			// If IE, return version number.
			if (Idx > 0) {
				return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)), 10);
			}

			// If IE 11 then look for Updated user agent string.
			else if (!!navigator.userAgent.match(/Trident\/7\./))
				return 11;

			else
				return 0; //It is not IE
		},
		setMediaMode: function() {
			try {
				if ($.browser.use_mediamode === true) {
					mediamode = window.getComputedStyle(document.body, ':after').getPropertyValue('content');

					if ((mediamode == '"mobile"') || (mediamode == 'mobile') || (mediamode == "'mobile'")) {
						$.browser.is_mobile = true;
					}
					if ((mediamode == '"tablet"') || (mediamode == 'tablet') || (mediamode == "'tablet'")) {
						$.browser.is_mobile = false;
						$.browser.is_tablet = true;
					}

					if ((mediamode == '"desktop"') || (mediamode == 'desktop') || (mediamode == "'desktop'")) {
						$.browser.is_mobile = false;
					}
					if ((mediamode == '"none"') || (mediamode == 'none') || (mediamode == "'none'")) {
						$.browser.is_mobile = false;
					}

					if ((mediamode == '"ipadls"') || (mediamode == 'ipadls') || (mediamode == "'ipadls'")) {
						$.browser.is_mobile = false;
						$.browser.ipad_ls = true;
					}
				}
			} catch (e) {
			}
		},

		setClasses: function() {
			if ($.browser.is_mobile === true) {
				$('body').addClass('mobile');
			}

			if ($.browser.is_tablet === true) {
				$('body').addClass('tablet');
			}
		},

		setMobileAgent: function() {

			var md = new MobileDetect(window.navigator.userAgent);
			if (md.tablet() !== null) {
				$.browser.is_tablet = true;
			}

			//ext events
			isMobileAgent = {
				Android   : function() {
					return navigator.userAgent.match(/Android/i);
				},
				BlackBerry: function() {
					return navigator.userAgent.match(/BlackBerry|BB10/i);
				},
				iOS       : function() {
					return navigator.userAgent.match(/iPhone|iPad|iPod/i);
				},
				Opera     : function() {
					return navigator.userAgent.match(/Opera Mini/i);
				},
				Windows   : function() {
					return navigator.userAgent.match(/IEMobile/i);
				},
				any       : function() {
					return (isMobileAgent.Android() || isMobileAgent.BlackBerry() || isMobileAgent.iOS() || isMobileAgent.Opera() || isMobileAgent.Windows());
				}
			};

			if (isMobileAgent.any()) {
				$.browser.is_mobile = true;
			}
		}
	};

});
